import React from 'react';
import { Redirect } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

function RequireUser({ children, redirectTo = '/login' }) {
  const { auth } = useAuth();

  if (!auth.initialized) {
    return null;
  }

  return auth.loggedIn ? children : <Redirect to={redirectTo} />;
}

export default RequireUser;
